// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__8QKK-","legacyBtn":"MutateMid_legacyBtn__27aTF"};